<ion-content class="app" slot="fixed">
  <div class="app__content onboarding">
    <div class="onboarding__content">
      <span [inlineSVG]="'/assets/illustrations/confetti.svg'"></span>
      <h1>{{ 'onboarding.success.title' | translate }}</h1>
      <p>{{ 'onboarding.success.desc' | translate }}</p>
      <button class="onboarding__content__button" routerLink="/feed">
        <span> {{ 'onboarding.success.button' | translate }} </span>
        <span
          class="icon"
          [inlineSVG]="'/assets/icons/card/arrow-right.svg'"
        ></span>
      </button>
    </div>
  </div>
</ion-content>
